<template>
  <div>
    <!--    second Version -->
    <b-row v-if="getVersion === 'v2'">
      <b-col lg="7" class="d-none d-lg-block mt-10">
        <b-container>
          <img src="@/assets/images/mainPaymentImage.png" width="100%" />
        </b-container>
      </b-col>
      <b-col cols="12" lg="5" class="pt-5">
        <b-col
          class="d-flex justify-content-center align-items-center pb-10 black-text font-size-medium-small font-weight-bold"
        >
          <span>{{ $translate("enterCardAndMobile") }}</span>
        </b-col>
        <b-container
          class="background-secondary border-radius-10px border-light-gray-1px"
        >
          <b-row class="pt-3">
            <b-col cols="12" class="d-flex justify-content-end pt-2">
              <img src="@/assets/images/shetab-on.png" height="35" width="50" />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="midnight-blue-text font-size-small pb-1 font-weight-bold"
            >
              {{ $translate("cardNumber") }}:
            </b-col>
            <b-col cols="12" class="pb-4 midnight-blue-text font-size-xs"
              >{{ $translate("enter16DigitCardNumber") }}
            </b-col>
          </b-row>

          <b-row
            cols="12"
            class="direction-ltr m-0 pb-3"
            v-click-outside="clickedOutSide"
          >
            <div class="input-group p-0">
              <div class="input-group-prepend">
                <span class="input-group-text fill-height">
                  <img
                    :src="bankImageSource"
                    height="25"
                    width="25"
                    v-if="checkIfInputNotEmpty"
                  />
                </span>
              </div>
              <input
                v-for="(key, i) in creditCardInfo"
                required
                @click="checkLocalStorage()"
                @paste="onCreditCardPaste($event, 'creditCardInfo')"
                @input="handleAutoFocus(i)"
                :key="i"
                :ref="`credit-card-input-key${i}`"
                pattern="\d*"
                inputmode="numeric"
                v-model="key.value"
                class="col-2 form-control"
                placeholder="0000"
                v-mask="'####'"
                mask="false"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
                style="margin-inline: 3px"
              />
              <div
                v-if="!isLocalStorageEmpty && showSaveCard"
                class="saved-cards-drop-down-container"
                ref="saveCards"
              >
                <div
                  class="saved-cards-drop-down"
                  :class="{ noBorder: index == filteredSavedCards.length - 1 }"
                  v-for="(item, index) in filteredSavedCards"
                  :key="index"
                >
                  <div
                    class="cursor-pointer"
                    @click="useThisCardInfoFromLocalStorage(item, index)"
                  >
                    {{ item | dashSep }}
                  </div>
                </div>
              </div>
            </div>
          </b-row>
        </b-container>
        <b-container
          class="background-secondary border-radius-10px border-light-gray-1px my-3 pt-3"
        >
          <b-row>
            <b-col
              cols="12"
              class="black-text font-size-small pb-1 font-weight-bold"
              >{{ $translate("mobilePhone") }}:
            </b-col>
            <b-col cols="12" class="pb-1 black-text font-size-xs"
              >{{ $translate("enterMobilePhoneNumber") }}
            </b-col>
          </b-row>
          <b-row class="input-group direction-ltr m-0 pb-3">
            <b-col cols="12" class="p-0 d-flex justify-content-center">
              <b-form-input
                id="mobile-number-input"
                name="mobile-number-input"
                placeholder="09000000000"
                class="col-2 form-control"
                pattern="\d*"
                inputmode="numeric"
                :class="{ secondVersionInputs: getVersion === 'v2' }"
                required
                v-model="mobileNumber"
                v-mask="'###########'"
                :state="mobileNumberValidation"
                style="margin-inline: 3px"
              >
              </b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="black-text font-size-small pb-1 font-weight-bold"
            >
              {{ $translate("selectAmount") }}
            </b-col>
            <b-col cols="12" class="pb-1 black-text font-size-xs"
              >{{ $translate("enterSelectedAmount") }}
            </b-col>
          </b-row>
          <b-row class="input-group direction-rtl m-0 pb-12">
            <b-col cols="12" class="p-0 d-flex justify-content-center">
              <b-form-select
                class="form-control"
                v-model="selectedAmount"
                :options="options"
                required
                :class="{ secondVersionInputs: getVersion === 'v2' }"
              ></b-form-select>
            </b-col>
          </b-row>
          <!--          <b-row>-->
          <!--            <b-col cols="12"-->
          <!--                   style="padding-top: 10px; padding-bottom: 15px;font-size: 0.8rem; font-weight: bold; color: black">-->
          <!--              انتخاب درگاه:-->
          <!--            </b-col>-->
          <!--            <b-form-group style="padding-bottom: 25px;">-->
          <!--              <b-row class="gateAwayFirstRow" style="margin-bottom: 20px">-->
          <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
          <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="auto" id="automatic"-->
          <!--                         style="box-shadow: inset 0 0 10px black !important"-->
          <!--                         v-model="selectedPaymentGate">-->
          <!--                  <label class="btn paymentGateAwayButtons" for="automatic">-->
          <!--                    <b-row>-->
          <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
          <!--                        <img src="../assets/shaparak-on.png" height="25" width="25"/>-->
          <!--                      </b-col>-->
          <!--                      <b-col cols="8" class="gateCol">-->
          <!--                        <span class="gateAwayText">اتوماتیک</span></b-col>-->
          <!--                      <b-col cols="3">-->
          <!--                        <span v-if="selectedPaymentGate == 'auto'">-->
          <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
          <!--                              width="16" height="16"-->
          <!--                              fill="currentColor"-->
          <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
          <!--                              viewBox="0 0 16 16">-->
          <!--                           <path-->
          <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
          <!--                          </svg>-->
          <!--                        </span>-->
          <!--                      </b-col>-->
          <!--                    </b-row>-->
          <!--                  </label>-->
          <!--                </b-col>-->
          <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
          <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="melli" id="melliBank"-->
          <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
          <!--                  <label class="btn paymentGateAwayButtons" for="melliBank">-->
          <!--                    <b-row>-->
          <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
          <!--                        <img src="../assets/bankmeli.png" height="25" width="25"/>-->
          <!--                      </b-col>-->
          <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک ملی</span></b-col>-->
          <!--                      <b-col cols="3">-->
          <!--                        <span v-if="selectedPaymentGate == 'melli'">-->
          <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
          <!--                              width="16" height="16"-->
          <!--                              fill="currentColor"-->
          <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
          <!--                              viewBox="0 0 16 16">-->
          <!--                           <path-->
          <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
          <!--                          </svg>-->
          <!--                        </span>-->
          <!--                      </b-col>-->
          <!--                    </b-row>-->
          <!--                  </label>-->
          <!--                </b-col>-->
          <!--              </b-row>-->
          <!--              <b-row style="padding-bottom: 20px;">-->
          <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
          <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="mellat" id="mellatBank"-->
          <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
          <!--                  <label class="btn paymentGateAwayButtons" for="mellatBank">-->
          <!--                    <b-row>-->
          <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
          <!--                        <img src="../assets/bankmelat.png" height="25" width="25"/>-->
          <!--                      </b-col>-->
          <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک ملت</span></b-col>-->
          <!--                      <b-col cols="3">-->
          <!--                        <span v-if="selectedPaymentGate == 'mellat'">-->
          <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
          <!--                              width="16" height="16"-->
          <!--                              fill="currentColor"-->
          <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
          <!--                              viewBox="0 0 16 16">-->
          <!--                           <path-->
          <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
          <!--                          </svg>-->
          <!--                        </span>-->
          <!--                      </b-col>-->
          <!--                    </b-row>-->
          <!--                  </label>-->
          <!--                </b-col>-->
          <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
          <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="ayandeh" id="ayandehBank"-->
          <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
          <!--                  <label class="btn paymentGateAwayButtons" for="ayandehBank">-->
          <!--                    <b-row>-->
          <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
          <!--                        <img src="../assets/ayandebank.png" height="25" width="30"/>-->
          <!--                      </b-col>-->
          <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک آینده</span></b-col>-->
          <!--                      <b-col cols="3">-->
          <!--                        <span v-if="selectedPaymentGate == 'ayandeh'">-->
          <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
          <!--                              width="16" height="16"-->
          <!--                              fill="currentColor"-->
          <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
          <!--                              viewBox="0 0 16 16">-->
          <!--                           <path-->
          <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
          <!--                          </svg>-->
          <!--                        </span>-->
          <!--                      </b-col>-->
          <!--                    </b-row>-->
          <!--                  </label>-->
          <!--                </b-col>-->
          <!--              </b-row>-->
          <!--            </b-form-group>-->
          <!--          </b-row>-->

          <b-row class="pb-5">
            <b-col cols="4">
              <button
                type="button"
                class="decline-button"
                @click="cancelPayment"
                :class="{ newVersionButtons: getVersion === 'v2' }"
              >
                <span class="button-texts"> {{ $translate("cancel") }}</span>
              </button>
            </b-col>
            <b-col cols="8">
              <button
                type="button"
                class="go-to-next-button background-light-green"
                @click="submitInfo()"
                :class="{ newVersionButtons: getVersion === 'v2' }"
              >
                <b-row class="fill-width">
                  <b-col cols="10"
                    ><span class="button-texts">
                      {{ $translate("nextStep") }}</span
                    ></b-col
                  >
                  <b-col cols="2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="currentColor"
                      class="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                      />
                    </svg>
                  </b-col>
                </b-row>
              </button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>

    <!--    /second Version -->

    <!--    first Version -->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getVersion === 'v1' && !getGatewayPendingFlag">
        <b-col lg="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("register") }}
              </h1>
              <p class="font-size-large text-center dodger-blue-text">
                {{ $translate("onlyEnterCardNumberAndMobile") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5" class="second-container-min-height">
          <shetab-stepper
            class="shetabStepper"
            :whichPageIsIt="'shetab'"
          ></shetab-stepper>
          <b-col
            class="pb-1 midnight-blue-text font-size-medium-small font-weight-bold"
          >
            <span>{{ $translate("onlyEnterCardNumberAndMobile") }}</span>
          </b-col>
          <b-container
            class="first-container-min-height border-light-gray-1px background-secondary border-radius-10px"
          >
            <b-row class="pt-3" no-gutters>
              <b-col cols="12" class="d-flex justify-content-end pt-2">
                <img
                  src="@/assets/images/shetab-on.png"
                  height="35"
                  width="50"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="midnight-blue-text font-size-small pb-1 font-weight-bold"
              >
                {{ $translate("cardNumber") }}:
              </b-col>
              <b-col cols="12" class="pb-4 midnight-blue-text font-size-xs"
                >{{ $translate("enter16DigitCardNumber") }}
              </b-col>
            </b-row>
            <b-row
              class="mb-0 pb-3 direction-ltr"
              v-click-outside="clickedOutSide"
            >
              <!--            if the credit card number was available on the store-->
              <b-row
                no-gutters
                class="direction-ltr m-0 p-0"
                v-if="isCreditCardReceivedFromServer && !getGatewayPendingFlag"
              >
                <b-col cols="12">
                  <div class="input-group p-0">
                    <div class="input-group-prepend" v-if="bankImageSource">
                      <span class="input-group-text fill-height">
                        <img
                          :src="bankImageSource"
                          height="25"
                          width="25"
                          v-if="checkIfInputNotEmpty"
                        />
                      </span>
                    </div>
                    <input
                      v-for="(key, i) in creditCardInfo"
                      :value="creditCardInfo[i].value"
                      :key="i"
                      readonly
                      :class="{ secondVersionInputs: getVersion === 'v2' }"
                      class="col-2 form-control mx-1"
                    />
                  </div>
                </b-col>
              </b-row>
              <!--            if credit card number was added by user-->
              <div
                class="input-group p-0"
                v-if="!isCreditCardReceivedFromServer"
              >
                <div class="input-group-prepend" v-if="bankImageSource">
                  <span class="input-group-text fill-height">
                    <img
                      :src="bankImageSource"
                      height="25"
                      width="25"
                      v-if="checkIfInputNotEmpty"
                    />
                  </span>
                </div>
                <input
                  v-for="(key, i) in creditCardInfo"
                  required
                  @paste="onCreditCardPaste($event, 'creditCardInfo')"
                  @click="checkLocalStorage()"
                  @input="handleAutoFocus(i)"
                  :id="`credit-card-input-key${i}`"
                  :key="i"
                  v-model="key.value"
                  pattern="\d*"
                  inputmode="numeric"
                  class="col-2 form-control mx-1"
                  placeholder="0000"
                  v-mask="'####'"
                  mask="false"
                />
                <div
                  v-if="!isLocalStorageEmpty && showSaveCard"
                  class="saved-cards-drop-down-container"
                  ref="saveCards"
                >
                  <div
                    class="saved-cards-drop-down"
                    :class="{
                      noBorder: index == filteredSavedCards.length - 1,
                    }"
                    v-for="(item, index) in filteredSavedCards"
                    :key="index"
                  >
                    <div
                      class="cursor-pointer"
                      @click="useThisCardInfoFromLocalStorage(item, index)"
                    >
                      {{ item | dashSep }}
                    </div>
                  </div>
                </div>
              </div>
              <transition
                name="animate__fadeIn"
                :duration="200"
                enter-active-class="animate__animated animate__fadeIn "
                leave-active-class="animate__animated animate__fadeOut "
                appear
              >
                <b-col
                  cols="12"
                  class="d-flex justify-content-end align-items-center pt-3"
                  v-if="
                    !secondContainerVisibility &&
                    creditCardInfo[3].value.length === 4
                  "
                >
                  <span class="light-red-text font-size-xs font-weight-bold">
                    {{ $translate("invalidCardNumber") }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex justify-content-end align-items-center pt-3"
                  v-else-if="tempSaderatBankDisabled"
                >
                  <span class="light-red-text font-size-xs font-weight-bold">
                    {{ $translate("saderatNoGatewaySupport") }}
                  </span>
                </b-col>
              </transition>
            </b-row>
          </b-container>
          <!--          second container-->
          <!--          <b-collapse id="collapse-1" class="nav-collapse" v-model="secondContainerVisibility">-->
          <b-container
            id="second-container"
            class="background-secondary border-radius-10px border-light-gray-1px my-3 pt-3"
          >
            <b-row>
              <b-col
                cols="12"
                class="pb-1 midnight-blue-text font-size-small font-weight-bold"
              >
                {{ $translate("mobilePhone") }}:
              </b-col>
              <b-col cols="12" class="pb-1 midnight-blue-text font-size-xs"
                >{{ $translate("enterMobilePhoneNumber") }}
              </b-col>
            </b-row>
            <b-row cols="12 input-group direction-ltr m-0 pb-3">
              <b-form-input
                id="mobile-number-input"
                name="mobile-number-input"
                placeholder="09000000000"
                class="col-2 form-control mx-1"
                pattern="\d*"
                inputmode="numeric"
                required
                v-model="mobileNumber"
                v-mask="'###########'"
                :state="mobileNumberValidation"
                :readonly="isPhoneNumberReceivedFromServer"
              ></b-form-input>
            </b-row>
            <!--          if the paying amount was not available user must select-->
            <b-row v-if="!isShetabAmountsReceivedFromServer">
              <b-col
                cols="12"
                class="pb-1 midnight-blue-text font-size-small font-weight-bold"
              >
                {{ $translate("selectAmount") }}
              </b-col>
              <b-col cols="12" class="pb-1 midnight-blue-text font-size-xs"
                >{{ $translate("enterSelectedAmount") }}
              </b-col>
            </b-row>
            <!--          if the paying amount was not available user must select-->
            <b-row
              cols="12"
              class="input-group direction-rtl m-0 pb-3"
              v-if="!isShetabAmountsReceivedFromServer"
            >
              <b-form-select
                class="form-control"
                v-model="selectedAmount"
                :options="options"
                required
              ></b-form-select>
            </b-row>
            <!--          &lt;!&ndash;          if paying amount was available and it was an list of prices very rare situation&ndash;&gt;-->
            <!--          <b-row cols="12 input-group" style="direction: rtl; margin: 0px !important; padding-bottom:  15px;"-->
            <!--                 v-if="getPayingAmount && typeof getPayingAmount === 'object'">-->
            <!--            <b-form-select class="form-control" v-model="selectedAmount" :options="options"-->
            <!--                           required></b-form-select>-->
            <!--          </b-row>-->
            <b-row
              v-if="
                isShetabAmountsReceivedFromServer &&
                getPayingAmount &&
                getPayingAmount.split(',').length === 1
              "
            >
              <b-col
                cols="12"
                class="pb-1 midnight-blue-text font-size-small font-weight-bold"
              >
                {{ $translate("payingAmount") }}
              </b-col>
            </b-row>
            <!--          if the paying amount was available on store -->
            <b-row
              cols="12"
              class="input-group direction-rtl m-0 pb-3"
              v-if="
                isShetabAmountsReceivedFromServer &&
                getPayingAmount &&
                getPayingAmount.split(',').length === 1
              "
            >
              <input
                :value="
                  $options.filters.commaSep(selectedAmount) +
                  $translate('toman')
                "
                readonly
                :class="{ secondVersionInputs: getVersion === 'v2' }"
                class="col-2 form-control mx-1 font-size-medium-small font-weight-bold"
              />
            </b-row>

            <!--          <b-row>-->
            <!--            <b-col cols="12"-->
            <!--                   style="padding-top: 10px; padding-bottom: 15px;font-size: 0.8rem; font-weight: bold; color: midnightblue">-->
            <!--              انتخاب درگاه:-->
            <!--            </b-col>-->
            <!--            <b-form-group>-->
            <!--              <b-row class="gateAwayFirstRow" style="margin-bottom: 20px">-->
            <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
            <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="auto" id="automatic"-->
            <!--                         v-model="selectedPaymentGate">-->
            <!--                  <label class="btn paymentGateAwayButtons" for="automatic">-->
            <!--                    <b-row>-->
            <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
            <!--                        <img src="../assets/shaparak-on.png" height="25" width="25"/>-->
            <!--                      </b-col>-->
            <!--                      <b-col cols="8" class="gateCol">-->
            <!--                        <span class="gateAwayText">اتوماتیک</span></b-col>-->
            <!--                      <b-col cols="3">-->
            <!--                        <span v-if="selectedPaymentGate == 'auto'">-->
            <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
            <!--                              width="16" height="16"-->
            <!--                              fill="currentColor"-->
            <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
            <!--                              viewBox="0 0 16 16">-->
            <!--                           <path-->
            <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
            <!--                          </svg>-->
            <!--                        </span>-->
            <!--                      </b-col>-->

            <!--                    </b-row>-->
            <!--                  </label>-->
            <!--                </b-col>-->
            <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
            <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="melli" id="melliBank"-->
            <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
            <!--                  <label class="btn paymentGateAwayButtons" for="melliBank">-->
            <!--                    <b-row>-->
            <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
            <!--                        <img src="../assets/bankmeli.png" height="25" width="25"/>-->
            <!--                      </b-col>-->
            <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک ملی</span></b-col>-->
            <!--                      <b-col cols="3">-->
            <!--                        <span v-if="selectedPaymentGate == 'melli'">-->
            <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
            <!--                              width="16" height="16"-->
            <!--                              fill="currentColor"-->
            <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
            <!--                              viewBox="0 0 16 16">-->
            <!--                           <path-->
            <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
            <!--                          </svg>-->
            <!--                        </span>-->
            <!--                      </b-col>-->
            <!--                    </b-row>-->
            <!--                  </label>-->
            <!--                </b-col>-->
            <!--              </b-row>-->
            <!--              <b-row style="padding-bottom: 20px;">-->
            <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
            <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="mellat" id="mellatBank"-->
            <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
            <!--                  <label class="btn paymentGateAwayButtons" for="mellatBank">-->
            <!--                    <b-row>-->
            <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
            <!--                        <img src="../assets/bankmelat.png" height="25" width="25"/>-->
            <!--                      </b-col>-->
            <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک ملت</span></b-col>-->
            <!--                      <b-col cols="3">-->
            <!--                        <span v-if="selectedPaymentGate == 'mellat'">-->
            <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
            <!--                              width="16" height="16"-->
            <!--                              fill="currentColor"-->
            <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
            <!--                              viewBox="0 0 16 16">-->
            <!--                           <path-->
            <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
            <!--                          </svg>-->
            <!--                        </span>-->
            <!--                      </b-col>-->
            <!--                    </b-row>-->
            <!--                  </label>-->
            <!--                </b-col>-->
            <!--                <b-col cols="12" sm="6" lg="12" xl="6" class="gateAwayRows">-->
            <!--                  <input type="radio" class="btn-check paymentGateAwayRadioButtons" value="ayandeh" id="ayandehBank"-->
            <!--                         autocomplete="off" v-model="selectedPaymentGate">-->
            <!--                  <label class="btn paymentGateAwayButtons" for="ayandehBank">-->
            <!--                    <b-row>-->
            <!--                      <b-col cols="1" style="padding: 0px; padding-right: 5px;">-->
            <!--                        <img src="../assets/ayandebank.png" height="25" width="30"/>-->
            <!--                      </b-col>-->
            <!--                      <b-col cols="8" class="gateCol"><span class="gateAwayText">بانک آینده</span></b-col>-->
            <!--                      <b-col cols="3">-->
            <!--                        <span v-if="selectedPaymentGate == 'ayandeh'">-->
            <!--                         <svg xmlns="http://www.w3.org/2000/svg"-->
            <!--                              width="16" height="16"-->
            <!--                              fill="currentColor"-->
            <!--                              class="bi bi-check-circle-fill checkMarkIcon"-->
            <!--                              viewBox="0 0 16 16">-->
            <!--                           <path-->
            <!--                               d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>-->
            <!--                          </svg>-->
            <!--                        </span>-->
            <!--                      </b-col>-->
            <!--                    </b-row>-->
            <!--                  </label>-->
            <!--                </b-col>-->
            <!--              </b-row>-->
            <!--            </b-form-group>-->
            <!--          </b-row>-->
            <b-row class="pb-4">
              <b-col cols="4">
                <button
                  type="button"
                  class="decline-button"
                  @click="cancelPayment"
                >
                  <span class="button-texts">
                    {{ $translate("cancel") }}
                  </span>
                </button>
              </b-col>
              <b-col cols="8">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="submitInfo()"
                  id="next-step-button"
                >
                  <b-row class="fill-width">
                    <b-col cols="10"
                      ><span class="button-texts">
                        {{ $translate("nextStep") }}</span
                      ></b-col
                    >
                    <b-col cols="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-row>
            <!--            <b-row>
                          <b-col class="flexCentering" style="padding-bottom: 25px;">
                            <button type="button" class="go-to-next-button" @click="openVideoPlayer()"
                                    style="background-color: rgb(252,183,2) !important; font-weight: bold">
                          <span style="color: rgb(39,30,23) !important">
                            راهنما
                          </span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                   style="color: rgb(39,30,23) !important"
                                   class="bi bi-info-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path
                                    d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                              </svg>
                            </button>
                          </b-col>
                        </b-row>-->
          </b-container>
          <!--          </b-collapse>-->
        </b-col>
        <VideoPlayer
          v-if="showVideo"
          @closeVideoClickedOutSide="clickedOutSideOfVideo"
          :videoAddress="videoAddress"
        />
      </b-row>
    </transition>
    <ShetabNationalCodeModal
      :visibility="shetabNationalCodeModalVisibility"
      @submitInfo="handleSubmitNationalCode($event)"
      @close="shetabNationalCodeModalVisibility = false"
    />
  </div>
</template>

<script>
import shetabStepper from "@/components/ShetabStepper";
import VideoPlayer from "@/components/VideoPlayer";
import { directBankMixin } from "@/mixins/ShetabMixins/DirectBankMixin";
import ShetabNationalCodeModal from "./Modals/ShetabNationalCodeModal.vue";

export default {
  name: "directBank",
  components: {
    VideoPlayer,
    shetabStepper: shetabStepper,
    ShetabNationalCodeModal,
  },
  mixins: [directBankMixin],
};
</script>

<style scoped>
.paymentGateAwayButtons {
  width: 100%;
  background: transparent;
  color: #aeaeae;
  border: 1px solid lightgray;
  border-radius: 10px;
}

.second-container-min-height {
  min-height: 560px;
}

.first-container-min-height {
  height: 200px;
}

input[type="radio"]:checked + label {
  box-shadow: inset 0 0 10px dodgerblue !important;
  color: black;
}

.saved-cards-drop-down {
  padding: 5px;
  background-color: #d3d3d3 !important;
  border-bottom: 1px solid #737373;
  border-radius: 2px;
}

.saved-cards-drop-down-container {
  position: absolute;
  top: 35px;
  width: 100%;
  border: 1px solid #737373;
  border-radius: 5px;
  z-index: 2000;
  box-shadow: 0px 0px 5px 5px #f1ecec;
}

.noBorder {
  border-bottom: none !important;
}

.activeBorder {
  background: #3d637d !important;
}

.shetabStepper {
  padding-bottom: 30px;
}

.activeStepper {
  color: #3d637d !important;
}

.checkMarkIcon {
  color: lawngreen;
}

.decline-button {
  width: 100%;
  height: 115%;
  border-radius: 10px;
  border: 1px solid black;
  background-color: transparent;
}

.go-to-next-button {
  width: 100%;
  height: 115%;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

.gateAwayText {
  font-size: 0.8rem;
}

@media only screen and (max-width: 990px) {
  .shetabStepper {
    padding-bottom: 0;
  }
}

@media only screen and (max-width: 1500px) and (min-width: 1200px) {
  .gateCol {
    padding: 0px !important;
    padding-right: 10px !important;
  }
}

@media only screen and (max-width: 1200px) {
  .gateAwayRows {
    padding-bottom: 10px;
  }

  .gateAwayFirstRow {
    margin-bottom: 0px !important;
  }
}

/*Second Version Css*/
.secondVersionInputs {
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid lightgrey !important;
}

.newVersionButtons {
  border-radius: 5px !important;
}
</style>
